'use strict';

import Vue from 'vue';
import axios from 'axios';
import store from './store'

let config = {
    // baseURL: process.env.baseURL || process.env.apiUrl || ""
    // timeout: 60 * 1000, // Timeout
    // withCredentials: true, // Check cross-site Access-Control
    baseURL: (process.env.NODE_ENV === "production" ? '/api/' : 'http://pixla.px.cz/api/'), //https://production.areafourindustries.com
    timeout: 30000
};

const _axios = axios.create(config);


_axios.interceptors.response.use(undefined, function (err) {
    return new Promise(function (resolve, reject) {
        if (err.status === 401 && err.config && !err.config.__isRetryRequest) {
            store.commit('logout')
        }
        throw err;
    });
});

Plugin.install = function(Vue, options) {
    Vue.axios = _axios;
    window.axios = _axios;
    Object.defineProperties(Vue.prototype, {
        axios: {
            get() {
                return _axios;
            },
        },
        $axios: {
            get() {
                return _axios;
            },
        },
    });
};

Vue.use(Plugin);

export default Plugin;
